import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'common/components/PageTitle';
import { Loader } from 'common/components/Loader';
import { BasePage } from 'hydra/pages/BasePage';

const BudgetManagementContent = lazy(() =>
    import('budget/components/BudgetManagementContent').then((m) => ({
        default: m.BudgetManagementContent,
    }))
);

export const BudgetManagementPage = () => {
    const [translate] = useTranslation();

    return (
        <BasePage contentContainerMaxWidth="lg">
            <PageTitle>
                {translate('budgetManagementPage.browserTitle')}
            </PageTitle>

            <Suspense fallback={<Loader />}>
                <BudgetManagementContent />
            </Suspense>
        </BasePage>
    );
};
